// Error components must be Client Components
'use client';

import { ErrorPageType, SITES } from '@woonstad/ui-public-sites';
import { useEffect } from 'react';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    if (error) {
      console.error('Error boundary caught error:', error);
    }
  }, [error]);

  return (
    <ErrorPageType site={SITES.Woonstad} />
  );
}
